import routes from './routes.tsx';
import { IModuleProps } from '../../core/utils/modules.tsx';

export default {
    name: 'assistants',
    routes,
} as IModuleProps;
